// File: /opt/dev_environment/assets/workspace/app-init/src/components/ModeSwitcher/ModeSwitcher.js

import React from 'react';
import { TRAINING_MODES } from '../../constants/leitner';
import './ModeSwitcher.css';

const GearIcon = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 00.12-.61l-1.92-3.32a.49.49 0 00-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 00-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96a.49.49 0 00-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.07.62-.07.94s.02.64.07.94l-2.03 1.58a.49.49 0 00-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6A3.6 3.6 0 1115.6 12 3.611 3.611 0 0112 15.6z" />
  </svg>
);

function ModeSwitcher({ value, onChange }) {
  return (
    <div className="mode-switcher">
      <div className="mode-switcher__label">
        <span className="mode-switcher__label-icon">
          <GearIcon />
        </span>
        Trainingsmodus
      </div>
      <div className="mode-switcher__options" role="radiogroup" aria-label="Trainingsmodus">
        <button
          className={`mode-switcher__option ${value === TRAINING_MODES.VOKABELN ? 'mode-switcher__option--active' : ''}`}
          role="radio"
          aria-checked={value === TRAINING_MODES.VOKABELN}
          onClick={() => onChange(TRAINING_MODES.VOKABELN)}
          type="button"
        >
          <span className="mode-switcher__option-icon">
            <GearIcon />
          </span>
          Vokabel-Modus
        </button>
        <button
          className={`mode-switcher__option ${value === TRAINING_MODES.VERBEN ? 'mode-switcher__option--active' : ''}`}
          role="radio"
          aria-checked={value === TRAINING_MODES.VERBEN}
          onClick={() => onChange(TRAINING_MODES.VERBEN)}
          type="button"
        >
          <span className="mode-switcher__option-icon">
            <GearIcon />
          </span>
          Verb-Modus
        </button>
      </div>
    </div>
  );
}

export default ModeSwitcher;